import { RegisterOptions } from 'react-hook-form';
import { EMAIL_MAX_LENGTH, validationEmailRules } from 'src/utils/validations/validateEmail';
import { ADDRESS_MAX_LENGTH, validationAddressRules } from 'src/utils/validations/validateAddress';
import { CITY_MAX_LENGTH, validationCityRules } from 'src/utils/validations/validateCity';
import {
  POSTCODE_MAX_LENGTH,
  validationPostcodeRules
} from 'src/utils/validations/validatePostcode';
import { NAME_MAX_LENGTH, validationNameRules } from 'src/utils/validations/validateName';
import {
  NATIONALITY_MAX_LENGTH,
  validationNationalityRules
} from 'src/utils/validations/validateNationality';

const FIELD_ALIASES: Record<string, RegExp> = {
  postcode: /postcode|zip|client_pincode/i
};

/** Подбирает набор правил валидации по заданному имени поля fieldName.
 * Имя поля в общем случае может быть любым и необязательно точно совпадать
 * с ключом объекта VALIDATION_RULES. Для таких ситуаций предусмотрен объект
 * FIELD_ALIASES - в нем некоторым ключам в соответствие ставится регулярное
 * выражение - так как например поле для ввода почтового индекса может
 * называться zip или client_pincode.
 */
export const getValidationRules = (fieldName: string) => {
  const VALIDATION_CONFIG: Record<string, { validationRules: RegisterOptions; maxLength: number }> =
    {
      email: {
        validationRules: validationEmailRules,
        maxLength: EMAIL_MAX_LENGTH
      },
      address: {
        validationRules: validationAddressRules,
        maxLength: ADDRESS_MAX_LENGTH
      },
      city: {
        validationRules: validationCityRules,
        maxLength: CITY_MAX_LENGTH
      },
      postcode: {
        validationRules: validationPostcodeRules,
        maxLength: POSTCODE_MAX_LENGTH
      },
      name: {
        validationRules: validationNameRules,
        maxLength: NAME_MAX_LENGTH
      },
      surname: {
        validationRules: validationNameRules,
        maxLength: NAME_MAX_LENGTH
      },
      nationality: {
        validationRules: validationNationalityRules,
        maxLength: NATIONALITY_MAX_LENGTH
      }
    };
  const matchedKey = Object.keys(FIELD_ALIASES).find((key) => FIELD_ALIASES[key]?.test(fieldName));

  return VALIDATION_CONFIG[matchedKey || fieldName] || {};
};
